export function genValorNombreEvento(evento) {
   return {name: evento.target.name, value: evento.target.checked};
}

export function genLabel(item) {
   return `${item.codigo} - ${item.denominacion}`;
}

export function genId(item) {
   return item.codigo;
}

export function eventoSimulado(name, value) {
   return {target: {name: name, value: value}};
}
